// Angular
import { Component } from '@angular/core';
import { ScrollTopOptions } from '@corebase/layout';
// Layout

@Component({
    selector: 'kt-scroll-top',
    templateUrl: './scroll-top.component.html',
    standalone: false
})
export class ScrollTopComponent {
  // Public properties
  scrollTopOptions: ScrollTopOptions = {
    offset: 300,
    speed: 600
  };
}
